document.addEventListener("DOMContentLoaded", () => {
  const contenedor = document.querySelector('.content-product');
  let currentActive = null;
  
  contenedor.addEventListener('mouseover', (e) => {
    const hijo = e.target.closest('.products');
    if (!hijo) return;
    
    if (currentActive) currentActive.classList.remove('hover-active');
    
    hijo.classList.add('hover-active');
    currentActive = hijo;
  });
  
  // Opcional: Limpiar al salir del contenedor
  contenedor.addEventListener('mouseleave', () => {
    if (currentActive) {
      currentActive.classList.remove('hover-active');
      currentActive = null;
    }
  });
});